module.exports = __webpack_public_path__ + "img/arrow_down.9139ba81.png";